export const FETCH_DATA_REQUEST_ORDER = "FETCH_DATA_REQUEST_ORDER";
export const FETCH_DATA_SUCCESS_ORDER = "FETCH_DATA_SUCCESS_ORDER";
export const FETCH_DATA_FAILURE_ORDER = "FETCH_DATA_FAILURE_ORDER";
export const UPDATE_ORDER_REFUND = "UPDATE_ORDER_REFUND";